import moment from 'moment-jalaali';
import { toPersianDigitsStr } from '../../utils/persianNumber';
import type { PurchaseInvoice, Supplier } from '../../services/supplierService';
import { WEB_BASE_URL } from '../../config/env';

/** 1234567 → «۱٬۲۳۴٬۵۶۷» */
export const faNum = (n?: number | null): string => {
  if (n === undefined || n === null || !Number.isFinite(Number(n))) return '—';
  const v = Math.round(Number(n));
  const s = Math.abs(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '٬');
  return (v < 0 ? '−' : '') + toPersianDigitsStr(s);
};

export const faToman = (n?: number | null): string => (n === undefined || n === null ? '—' : `${faNum(n)} تومان`);

export const faRial = (n?: number | null): string => (n === undefined || n === null ? '—' : `${faNum(n)} ریال`);

/** 0.2534 → «۲۵٫۳٪» */
export const faPercent = (ratio: number): string => {
  if (!Number.isFinite(ratio)) return '—';
  return `${toPersianDigitsStr((ratio * 100).toFixed(1)).replace('.', '٫')}٪`;
};

export const invoiceDateLabel = (inv: Pick<PurchaseInvoice, 'invoiceDateJalali' | 'invoiceDate'>): string => {
  if (inv.invoiceDateJalali) return toPersianDigitsStr(inv.invoiceDateJalali);
  if (inv.invoiceDate) return toPersianDigitsStr(moment(inv.invoiceDate).format('jYYYY/jMM/jDD'));
  return '—';
};

export const supplierName = (s: PurchaseInvoice['supplier'], byId?: Record<string, Supplier>): string => {
  if (!s) return '—';
  if (typeof s === 'string') return byId?.[s]?.name || '—';
  return s.name || '—';
};

export const storeName = (s: PurchaseInvoice['store']): string => {
  if (!s || typeof s === 'string') return '—';
  return s.name || s.storeName || '—';
};

export const WEB_BASE = WEB_BASE_URL;

/** Margin on sale price: (sale − cost) / sale */
export const marginOf = (cost: number, sale: number): number => (sale > 0 ? (sale - cost) / sale : NaN);
